import { Component, OnInit, ViewChild } from '@angular/core';
import { AssociateService } from '../../shared/services/associate.service';
import { TrainingService } from '../../shared/services/training.service';
import { Configuration } from '../../app.constants';
import { ToastService } from '../../shared/services/toast.service';
import { StaticValueService } from '../../shared/services/static-value.service';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Course} from '../trainingClass'
import { debounceTime } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { Sort } from '@angular/material';
import * as moment from 'moment'
@Component({
  selector: 'app-course-list',
  templateUrl: './course-list.component.html',
  styleUrls: ['./course-list.component.css']
})
export class CourseListComponent implements OnInit {

  public coursesList: Array<any> = [];
  public addedAssocaites=[];
  public serverApiUrl: string;
  public searchNameBeh = new BehaviorSubject<string>('');
  public searchNameObs = this.searchNameBeh.asObservable();
  
  @ViewChild('myForm')
  public myForm: NgForm ;
  public query: any;
  public search= {name:'',domain:'',status:"All"};
  public isProfileedit:Boolean = false;
  public staticDD: any;

  // paginator
  public pageSizeOptions = [ 5, 10, 15, 25, 50, 100];
  public pageSize = 10;
  public length = 0;




  constructor(
    private associateService:AssociateService,
    private trainingService:TrainingService,
    public config: Configuration,
    public toastService:ToastService,
    public staticDDListService: StaticValueService,
    public activeRoute:ActivatedRoute,
  
  ) {
    this.staticDDListService.getStaticValues().then(data=>{
      this.staticDD = JSON.parse(JSON.stringify(data.staticDD));
    })

   }

  ngOnInit() {

    this.query = {
      search: {
          'active': true,
          'name': { '$regex': '', $options: 'i' },
          // 'team': ''
          'domain': { '$regex': '', $options: 'i' },
          'status':[true,false] ,

      },
      sort: { 'name': 1 },
      pagination: {
          pageIndex: 0,
          pageSize: 10
      }
    };

    this.searchNameObs.pipe(debounceTime(700)).subscribe(value => {
      this.query.search['name']={'$regex': value, $options: 'i' },
      this.courseSearch();
    })

    this.query.search.status = this.search.status==="All"? [true,false]: this.search.status ;
    this.query.search.domain = { '$regex': this.search.domain, $options: 'i' };
    this.courseSearch();
  }

  nameSearched() {
    this.searchNameBeh.next(this.search.name);
  }
  onchange(){
    this.query.search.status = this.search.status==="All"? [true,false]: this.search.status ;
    this.query.search.domain = { '$regex': this.search.domain, $options: 'i' };
    this.courseSearch();
  }

  courseSearch(){
    this.trainingService.getAllCourses(this.query.search,this.query.sort,this.query.pagination.pageIndex*this.query.pagination.pageSize,this.query.pagination.pageSize)
    .subscribe(data=>{
      console.log(data);
      this.coursesList = Object.assign([],data['data']);
      this.length = data['length'];
    })
  }

  sortData(sort: Sort) {
    this.query.sort = {};
    if (sort.direction === 'asc') {
        this.query.sort[sort.active] = -1;
    } else if (sort.direction === 'desc') {
        this.query.sort[sort.active] = 1;
    }
    this.courseSearch();
}

getServerData(event) {
  this.query.pagination.pageIndex = event.pageIndex;
  this.query.pagination.pageSize = event.pageSize;
  this.courseSearch();
}


activeStatus(startdate,endDate){
  if (moment(startdate).diff(moment(), 'days') <=0  && moment().diff(moment(endDate), 'days') <= 0 ) {
   return true
  } else {
    return false;
  }
}
}
